( function () {
	/* globals angular */
	'use strict';

	function ReportListController ( $location, reportService, visualizeJs, Session, $window, $modal, logger, $q ) {
		var self = this;

		self.order      = true;
		self.activeSort = 'name';

		var transformEnv = {
			'stage' : 'staging.',
			'dev'   : 'dev.',
			'live'  : ''
		};

		function updateFailed () {
			logger.notifyError( 'Updating date last generated failed' );
		}

		function goToReport ( model, custom ) {
			function triggerVisualize () {
				return $q( function ( resolve, reject ) {
					var env = visualizeJs.getEnv();

					visualizeJs.visualize()( {
						'server' : 'https://jasper1.' + transformEnv[ env ] +  'schoolimprovement.com:8443/jasperserver-pro',
						'auth'   : {
							'token'     : encodeURIComponent( Session.getCredentials().sessionToken + '_edivate_' + env + '_proxy_' + Session.getCredentials().userId ),
							'preAuth'   : true,
							'tokenName' : 'pp'
						}
					}, resolve, reject );
				} );
			}

			if ( custom ) {
				self.fetch = true;
				triggerVisualize().then( function () {
					$q.all( [
						reportService.updateDateGenerated( model.id ),
						reportService.callEtlProcess()
					] ).then( function () {
						$window.location.href = model.path;
					}, updateFailed  );
				}, function () {
					self.fetch = false;
					logger.notifyError( 'Unable to login to custom reports.  Try again later.' );
				} );
			} else {
				$location.url( model.path );
			}
		}

		function changeFavStatus ( method, model ) {
			model.isfavorite = !model.isfavorite;
			reportService[ method ]( model );
		}

		function changeDataForDisplay ( data ) {
			self.reports = reportService.changeForDisplay( data );
		}

		function deleteCustomReport () {
			reportService.deleteCustomReport( this.model )
				.then( changeDataForDisplay );
		}

		function openDeleteModal ( model ) {
			var modalInstance = $modal.open( {
				'templateUrl'  : '/templates/components/delete-modal/delete-confirmation.html',
				'controller'   : 'DeleteConfirmationController',
				'controllerAs' : 'vm',
				'resolve'      : {
					'type' : function () {
						return 'Report';
					}
				}
			} );

			modalInstance.result
				.then( deleteCustomReport.bind( { 'model' : model } ) );
		}

		function changeSorting ( key ) {
			self.order      = self.activeSort === key && !self.order;
			self.activeSort = key;
		}

		self.goToReport         = goToReport;
		self.changeFavStatus    = changeFavStatus;
		self.deleteCustomReport = deleteCustomReport;
		self.openDeleteModal    = openDeleteModal;
		self.changeSorting      = changeSorting;
	}

	angular.module( 'app.report' )
		.controller( 'ReportListController', ReportListController );

	ReportListController.$inject = [ '$location', 'reportService', 'visualizeJs', 'Session', '$window', '$modal', 'logger', '$q' ];
} )( );
